import { privateDecrypt } from "crypto";
import React from "react";
import Contacts from "./Contacts";

import "./Summary.css";

interface SummaryProps {
  chosenElements: {};
  price: any;
  konfigured: {};
  drawing: string;
}

function Summary(props: SummaryProps) {
  const renderSummary = function (props: any) {
    return Object.keys(props.chosenElements).map((el) => (
      <li className="Summary-item" key={el}>
        {" "}
        <div>
          {" "}
          <img
            className="img-res"
            src={props.chosenElements[el].picture_choose}
            alt=""
          />
        </div>
        <div className="Summary-item-title"> {props.chosenElements[el].title} </div>{" "}
      </li>
    ));
  };
  return (
    <div className="Summary">
      <header className="Nav-header"></header>
      <ul className="Summary-list">
        <li className="Summary-item Summary-title">Aktualne wybory</li>
        {renderSummary(props)}
        <li className="Summary-price">
          przybliżona cena
          {/* <div>
            {"OCZKA "}
            {props.price["luvers_price"]
              ? props.price["luvers_price"].toFixed(2) + "PLN"
              : "0 PLN"}
          </div>
          <div>
            {"Material "}
            {props.price["material_price"]
              ? props.price["material_price"].toFixed(2) + " PLN"
              : "0 PLN"}
          </div> */}
          <hr />
          <div className="Summary-total">
            {props.price["total"]
              ? props.price["total"].toFixed(2) + " PLN"
              : "0 PLN"}
          </div>
        </li>
        <li className="Summary-button"><Contacts text="Kontakt" price={props.price} drawing={props.drawing} konfigured={props.konfigured}></Contacts>
        <div className="Summary-phone">+48 605 624 422</div>
        </li>
      </ul>
    </div>
  );
}

export default Summary;
